var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-call-to-action",
    },
    [
      _c(
        "button",
        {
          staticClass: "action-button",
          attrs: {
            title: _vm.unfold ? _vm.titleOpen : _vm.titleClosed,
          },
          on: {
            click: _vm.buttonAction,
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: _vm.unfold ? "arr_1down" : _vm.iconShape,
              size: 24,
            },
          }),
          _vm._v("\n        " + _vm._s(_vm.actionTitle) + "\n    "),
        ],
        1
      ),
      _vm._v(" "),
      _vm.unfold
        ? _c(
            "div",
            {
              staticClass: "cw-call-to-action-content",
            },
            [_vm._t("content")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }